import { render } from "./Important.vue?vue&type=template&id=79bfe60c&scoped=true&ts=true"
import script from "./Important.ts?vue&type=script&lang=ts"
export * from "./Important.ts?vue&type=script&lang=ts"

import "./Important.scss?vue&type=style&index=0&id=79bfe60c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bfe60c"]])

export default __exports__